import {useParams} from "react-router-dom";
import {useCallback, useEffect, useState} from "react";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import {SegmentViewer} from "../components/SegmentViewer";
import {MediaProp} from "../components/MediaProp";
import {MediaProvider, MediaPlayer} from "@vidstack/react";
import { defaultLayoutIcons, DefaultAudioLayout, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';
import {BookInterface, SegmentInterface, UrokInterface} from "./Notebook";
import {apiCallbacks} from "../App";


export interface LessonInterface {
    id: number;
    title: string;
    part: number;
    bookId: number;
    urokId: number;
    segmentId: number;
    availability: number;
}

export const Lesson = ({requireAuthCallback, authCheckCatchCallback}: apiCallbacks) => {
    const {lesson_id} = useParams();
    const [lesson, setLesson] = useState<LessonInterface>();
    const [player, setPlayer] = useState<JSX.Element>();
    const mediaProps = MediaProp.Query();
    const [segmentViewer, setSegmentViewer] = useState(<></>);
    const [bookData, setBookData] = useState<BookInterface>();
    const [segmentData, setSegmentData] = useState<SegmentInterface[]>();
    const getSegmentData = useCallback((realBookData: BookInterface, realSegmentData: SegmentInterface[]) => {
        if (lesson === undefined) return
        let quickNavBookData: BookInterface = {...realBookData}
        let quickNavSegmentData: SegmentInterface[] = [...realSegmentData]
        quickNavBookData.segments = [
            {
                id: 0,
                title: 'Бърза навигация',
            }
        ]
        let uroks: UrokInterface[] = []
        for (let i = 0; i < quickNavSegmentData.length; i++) {
            for (let j = 0; j < quickNavSegmentData[i].uroks.length; j++) {
                if ([lesson.urokId-1, lesson.urokId+1].includes(quickNavSegmentData[i].uroks[j].id)) {
                    const urok = quickNavSegmentData[i].uroks[j];
                    urok.lessons = [urok.lessons[0]]
                    uroks.push(urok)
                } else if (quickNavSegmentData[i].uroks[j].id === lesson.urokId) {
                    uroks.push(quickNavSegmentData[i].uroks[j])
                }
            }
        }
        quickNavSegmentData = [
            {
                id: 0,
                uroks: uroks
            }
        ]
        setBookData(quickNavBookData)
        setSegmentData(quickNavSegmentData)
    }, [lesson]);

    useEffect(() => {
        if (lesson_id === undefined) return
        const id = parseInt(lesson_id)
        fetch(`${process.env.REACT_APP_API}/lessons/${id}/`, {credentials: "include"})
            .then(requireAuthCallback)
            .then((data) => setLesson(data))
            .catch(authCheckCatchCallback);
    }, [authCheckCatchCallback, lesson_id, requireAuthCallback]);

    useEffect(() => {
        if (lesson?.title) document.title = lesson?.title.replace(/<\/?sup>/g, '').replace(/<\/?sub>/g, '')
        if (lesson === undefined) return
        setSegmentViewer(
            <SegmentViewer
                bookId={lesson.bookId}
                lessonId={lesson.id}
                scrollToLesson={!mediaProps.mobile} onSegmentData={getSegmentData}
                requireAuthCallback={requireAuthCallback}
                authCheckCatchCallback={authCheckCatchCallback}
            />
        )
    }, [authCheckCatchCallback, getSegmentData, lesson, mediaProps.mobile, requireAuthCallback])

    useEffect(() => {
        if (lesson === undefined) return
        setPlayer(<>
            <MediaPlayer
                title={lesson.title}
                src={`${process.env.REACT_APP_API}/lessons/${lesson.id}/playlist.m3u8`}
                aspectRatio="16/9"
                crossorigin=""
                poster="/preview.png"
                autoplay
                controls
                playsinline
            >
                <DefaultVideoLayout icons={defaultLayoutIcons}/>
                <DefaultAudioLayout icons={defaultLayoutIcons}/>
                <MediaProvider/>
            </MediaPlayer>

            <h1 dangerouslySetInnerHTML={{__html: lesson.title!!}}/>
            {(bookData !== undefined && segmentData !== undefined) &&
                <SegmentViewer
                    bookId={lesson.bookId}
                    initialBookData={bookData}
                    initialSegmentData={segmentData}
                    segmentNumerals={false}
                    lessonId={lesson.id}
                    requireAuthCallback={requireAuthCallback}
                    authCheckCatchCallback={authCheckCatchCallback}
                />
            }
        </>)
    }, [authCheckCatchCallback, bookData, lesson, requireAuthCallback, segmentData]);

    return (
        <div>
            {(lesson !== undefined && lesson.availability !== 1) &&
                <Alert role="alert" variant="warning" className="mx-4">Видеото може да не е налично в момента</Alert>
            }
            <div className="mt-3 px-2 w-100">
                <Col xs={mediaProps.mobile ? 'auto' : 6}
                     className={`${mediaProps.mobile ? '' : 'position-fixed'}`}>{player}</Col>
                {(lesson && !mediaProps.mobile) &&
                    <Col xs={6} className="p-0 ps-3 position-absolute end-0">
                        {segmentViewer}
                    </Col>
                }
            </div>
            {mediaProps.mobile &&
                <h4 className="mt-5 ps-2 mx-auto text-center">Навигация</h4>
            }
            {(lesson && mediaProps.mobile) && segmentViewer}
        </div>
    );
};